var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "ul_user_select" }, [
    _c("li", { staticClass: "select_content" }, [
      _c("img", {
        attrs: { src: _vm.getImage("top/content/choosepoint_01.webp") }
      }),
      _vm._v(" "),
      _vm._m(0)
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "select_content" }, [
      _c("img", {
        attrs: { src: _vm.getImage("top/content/choosepoint_02.webp") }
      }),
      _vm._v(" "),
      _vm._m(1)
    ]),
    _vm._v(" "),
    _c("li", { staticClass: "select_content" }, [
      _c("img", {
        attrs: { src: _vm.getImage("top/content/choosepoint_03.webp") }
      }),
      _vm._v(" "),
      _vm._m(2)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "pickup_title" }, [
        _vm._v("1.【明瞭会計】追加料金一切なし！")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        お客様がmm/styleで商品をカスタマイズすると、すぐにお見積り価格が表示されます。その価格から、追加で費用がかかることはございません。"
        ),
        _c("br"),
        _vm._v(
          "\n        明瞭価格をご確認いただきながら、お買い物をしていただけます。\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "pickup_title" }, [
        _vm._v("2.【品質保証】1年間の無償修理保証！")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        配達中の商品破損や、取扱説明書に従った使用状態で保証期間内に故障した場合は、無償修理の対応をさせていただきます。"
        ),
        _c("br"),
        _vm._v(
          "\n        mm/styleに掲載されている全ての商品が保証対象です。\n      "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "pickup_title" }, [
        _vm._v("3.【組設対応】プロによる組立設置対応が可能！")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n        商品の購入と合わせて家具のプロに組立設置を依頼することができるので、安心してご購入いただくことができます。"
        ),
        _c("br"),
        _vm._v(
          "\n        その場合、梱包材料は全て回収させていただきます。\n      "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bcd42e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bcd42e4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/top/DcSelectReason.vue
// module id = null
// module chunks = 